import { NumericFormat } from 'react-number-format'

function InputPriceCustom({
  value,
  onChange,
  className = '',
  placeholder = '฿',
  disabled = false
}) {
  return (
    <NumericFormat
      disabled={disabled}
      placeholder={placeholder}
      className={`form-control text-end ${className}`}
      type="text"
      value={value}
      onChange={onChange}
      allowLeadingZeros
      thousandSeparator=","
      allowNegative={false}
      decimalScale={2}
    />
  )
}

export default InputPriceCustom
